const accountTypeOverview = [

    {accountType: "bank",  level: 1, headerText: "Bank Savings Account Basic Information",
        label: "Bank Savings Accounts", sortNbr: 1, longDesc: "Total balance in all bank " +
            "saving accounts",
        imageURL: "savings.png", buttonText: "Bank Accounts",
        paragraph1: "A bank savings account is a safe place to keep your money while " +
            "it grows over time. It’s designed to help you save for short-term goals, emergencies, " +
            "or future needs — without the risk that comes with investing. ",
        itemListText: "In this game, you’ll explore different types of savings accounts: ",
        itemList: ["Regular Savings, which offer very low interest",
                   "High-Yield Savings, which pay better interest rates",
                   "Certificates of Deposit (CDs), which lock in your money for a  " +
                   "set time in exchange for higher returns"],
        paragraph2: "Each type has its own purpose — and learning how to choose the " +
            "right one can help you build a solid financial foundation." 
    },

    {accountType:  "retirement", level: 2, headerText: "Retirement Account 401(k) Summary",
        label: "Retirement Accounts", sortNbr: 2, longDesc: "Amount in all retirement 401(k) " +
            "accounts (excluding company match)",
        imageURL: "saving401k.png", buttonText: "Retirement Accounts 401(k)",
        paragraph1: "A 401(k) is a special type of retirement account offered by many employers. " +
            "It lets you invest money from your paycheck before taxes are taken out — and that " +
            "money can grow over time to help fund your life after you stop working. ",
        itemListText: "Most 401(k) plans give you a few types of investment options to choose from, " +
            "including: ",
        itemList: ["Conservative Fund: A low-risk option that focuses on protecting your money with " +
            "steady but smaller growth, often using bonds and stable investments.",
            "Balanced Fund: A medium-risk mix of stocks and bonds aiming for a balance between safety " +
            "and growth.", 
            "Aggressive Fund: A high-risk, high-reward option that invests mostly in stocks to grow " +
            "your money faster—but with more ups and downs."],
        paragraph2: "Understanding these choices helps you build a retirement plan that fits " +
            "your goals and comfort with risk — even if retirement feels far away now."
    },
  
    {accountType: "investments", level: 3, headerText: "Investments Summary",
        label: "Investments", sortNbr: 40, buttonText: "Investments",
        imageURL: "investments.png",
        paragraph1:  "Investing is a way to grow your money over time by putting it to work in " +
            "things like companies or governments. Unlike a savings account, investments come " +
            "with risk — but they also offer a chance for greater rewards in the long run.",
        itemListText: "In this module, you’ll learn about four common types of investments:",
        itemList: ["Bonds - Lend money to earn steady interest.",
             "Index Funds - Track the market with a mix of companies and investment types.", 
             "Mutual Funds - A money expert picks investments for you to maximize return.",
             "Stocks - Own a small piece of a company."],
        paragraph2:  "Knowing how each one works will help you start thinking like an " +
            "investor — weighing risk, reward, and what makes sense for your financial goals."
    }
]
export default accountTypeOverview;